/**
 *
 */

(function(window, undefined) {
    'use strict';
    var Route = function($stateProvider) {
        var onEnter = [
            'CblMessageSrvc',
            function(messaggiSrvc) {
                messaggiSrvc.reset();
            }
        ];

        var runner = [
            'MitomRunService',
            '$q',
            function(runService, $q) {
                var defer = $q.defer();
                runService.run().then(
                    function() {
                        defer.resolve();
                    },
                    function() {
                        defer.resolve();
                    }
                );

                return defer.promise;
            }
        ];

        $stateProvider
            .state('gestioneUtenteMito', {
                url: '/gestioneUtenteMito/:codiceUtente/:idPratica/:step/:ndg/:flagIngressoDaSceltaUtenza?:idAnagrafica',
                template: '<mitomgestione-utente></mitomgestione-utente>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Gestione utente MITO',
                    parent: 'schedaCliente'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('collocamentoUtenteMito', {
                url: '/nuovoUtenteMito/:codiceUtente/:idPratica/:step/:ndg/:codiceProdotto?:idAnagrafica',
                template: '<mitomgestione-utente></mitomgestione-utente>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Nuovo utente MITO',
                    parent: 'prodotti'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('datiUtenteMito', {
                url: '/datiUtenteMito?:idAnagrafica',
                template: '<mitomdati-utente-mito></mitomdati-utente-mito>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Dati utente MITO',
                    parent: 'gestioneUtenteMito'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('accessoNotifiche', {
                url: '/accessoNotifiche',
                template: '<mitomaccesso-notifiche></mitomaccesso-notifiche>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Accesso e Notifiche',
                    parent: 'gestioneUtenteMito'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('visibilitaRapporti', {
                url: '/visibilitaRapporti',
                template: '<mitomvisibilita-rapporti></mitomvisibilita-rapporti>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Visibilità rapporti',
                    parent: 'gestioneUtenteMito'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('invioCredenzialiMito', {
                url: '/invioCredenzialiMito/:codiceUtente/:ndg/:flagIngressoDaSceltaUtenza?:idAnagrafica',
                template: '<mitominvio-credenziali></mitominvio-credenziali>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Invio credenziali',
                    parent: 'gestioneUtenteMito'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('auditEventi', {
                url: '/auditEventi/:codiceUtente/:ndg',
                template: '<mitom-audit></mitom-audit>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Audit',
                    parent: 'gestioneUtenteMito'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('vipPage', {
                url: '/gestioneVip/:codiceUtente/:ndg',
                template: '<mitom-vip></mitom-vip>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Audit',
                    parent: 'gestioneUtenteMito'
                },
                resolve: {
                    runner: runner
                }
            });
    };

    Route.$inject = ['$stateProvider'];

    angular.module('cbl.mitomanager.wa').config(Route);
})(window);